import { feverApiFetchOpts, fetches, methods } from 'api/commom';
import queryString from 'query-string';
import { MAX_LENGTH_PER_REQUEST, campaignTypes } from 'config/campaignType';
import {
    GET_CAMPAIGN_ERROR,
    GET_MESSAGE_ERROR,
    UPDATE_CAMPAIGN_STATUS_ERROR
} from 'apiHandler/campaign';

export function getCampaignApi(sponsorId, campaignId) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}`,
        feverApiFetchOpts(),
        {
            throwErrConfigs: GET_CAMPAIGN_ERROR
        }
    ).then(resp => resp);
}

export function getCampaignMessageApi(sponsorId, campaignId, messageId) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}/messages${
            messageId ? `/${messageId}` : ''
        }`,
        feverApiFetchOpts(),
        {
            throwErrConfigs: GET_MESSAGE_ERROR
        }
    ).then(resp => resp);
}

export function getCampaignListApi(
    sponsorId,
    { perPage = MAX_LENGTH_PER_REQUEST, page, type = campaignTypes.STORY_MENTION }
) {
    const qs = queryString.stringify({
        perPage,
        page,
        type
    });
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools${qs && `?${qs}`}`,
        feverApiFetchOpts()
    ).then(resp => resp);
}

export function getCampaignMemberList(sponsorId, campaignId, { page = 1, perPage = 10 }) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}/sent?page=${page}&perPage=${perPage}`,
        feverApiFetchOpts(),
        { dataKeys: 'data' }
    );
}

export function getPasscodePromos(sponsorId) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/passcode-promos`,
        feverApiFetchOpts()
    ).then(resp => resp);
}

export function updateCampaignMessageApi(
    sponsorId,
    campaignId,
    messageId,
    { type, promotionUuid, content, settings }
) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}/messages${
            messageId ? `/${messageId}` : ''
        }`,
        feverApiFetchOpts({
            method: methods.PATCH,
            body: { type, content: JSON.stringify(content), promotionUuid, settings }
        })
    ).then(resp => resp);
}

export function updateCampaignStatusApi(sponsorId, campaignId, status) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}/status`,
        feverApiFetchOpts({
            method: methods.PATCH,
            body: { status }
        }),
        {
            throwErrConfigs: UPDATE_CAMPAIGN_STATUS_ERROR
        }
    ).then(resp => resp);
}

export function updateCampaignApi(sponsorId, campaignId, body) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}`,
        feverApiFetchOpts({
            method: methods.PATCH,
            body
        })
    ).then(resp => resp);
}

export function createCampaignApi(sponsorId, { name, type, limit }) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools`,
        feverApiFetchOpts({
            method: methods.POST,
            body: { name, type, limit }
        })
    ).then(resp => resp);
}

export function createCampaignMessageApi(sponsorId, campaignId, { promotionUuid, type, content }) {
    const formData = new FormData();
    if (promotionUuid) {
        formData.append('promotionUuid', promotionUuid);
    }
    formData.append('type', type);
    formData.append('content', JSON.stringify(content));
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}/messages`,
        feverApiFetchOpts({ method: methods.POST, formData })
    ).then(resp => resp);
}

export function deleteCampaignApi(sponsorId, campaignId) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}`,
        feverApiFetchOpts({ method: methods.DELETE })
    ).then(resp => resp);
}

export function getCampaignPreviewCodeApi(sponsorId, campaignId) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}/preview-code`,
        feverApiFetchOpts({ method: methods.POST })
    ).then(resp => resp);
}

export function getCampaignAnalysisApi({ sponsorId, campaignId, startDate, endDate }) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/${campaignId}/analysis?startDate=${startDate}&endDate=${endDate}`,
        feverApiFetchOpts()
    ).then(resp => resp);
}

/**
 * @method getCampaignLoadsUsageApi 取得該週期Campaign 使用量 API
 * @description https://app.clickup.com/t/86evgbt3b
 * @param  {string} sponsorId Sponsor Uuid
 * @return  {promise}
 */
export function getCampaignLoadsUsageApi(sponsorId) {
    return fetches(
        `/services/campaigns/sponsors/${sponsorId}/tools/loads-usage`,
        feverApiFetchOpts()
    ).then(resp => resp);
}
